import React from 'react';
import { Card } from './ui/card';
import { Users, Heart, Trophy, Shield } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20" style={{ backgroundColor: 'white' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-blue)' }}>
              About HR KinderNova
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
              A nurturing environment where children grow, learn, and thrive through play-based education.
            </p>
            <div className="w-24 h-1 mx-auto mt-4 rounded-full" style={{ backgroundColor: 'var(--primary-yellow)' }}></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Left: Where Learning Meets Fun Collage */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl h-[500px] bg-gray-50">
                <img
                  src="https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/hlqo06oq_image.png"
                  alt="Where Learning Meets Fun - HR KinderNova Playschool"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 p-6 rounded-2xl shadow-xl" style={{ backgroundColor: 'var(--primary-red)' }}>
                <p className="font-bold text-3xl heading-playful text-white">Since 1943</p>
                <p className="text-white text-lg">Legacy</p>
              </div>
            </div>

            {/* Right: Content */}
            <div className="space-y-6">
              <h3 className="text-3xl font-bold heading-playful" style={{ color: 'var(--primary-red)' }}>
                Welcome to Our Playschool Family
              </h3>
              <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                HR KinderNova is rooted in the rich educational legacy of HR Hindu High School, which has been nurturing young minds since 1943. We bring decades of trusted experience to early childhood education.
              </p>
              <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                Our playschool offers a safe, joyful, and stimulating environment where children from Playgroup to 1st Class develop essential skills through play-way methods and activity-based learning.
              </p>
              <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                With modern AC classrooms, CCTV security, and experienced teachers, we ensure your child's safety and holistic development every step of the way.
              </p>
            </div>
          </div>

          {/* Values Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {
              [
                { icon: Users, title: 'Experienced Teachers', desc: 'Qualified and caring educators', color: 'var(--primary-blue)' },
                { icon: Heart, title: 'Nurturing Environment', desc: 'Safe and loving atmosphere', color: 'var(--primary-red)' },
                { icon: Trophy, title: 'Activity-Based Learning', desc: 'Hands-on education approach', color: 'var(--primary-yellow)' },
                { icon: Shield, title: 'Safe & Secure', desc: 'CCTV monitored campus', color: 'var(--primary-green)' },
              ].map((item, index) => (
                <Card key={index} className="p-6 rounded-3xl border-0 shadow-lg text-center hover:shadow-xl transition-shadow" style={{ backgroundColor: 'var(--surface-cream)' }}>
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: item.color }}>
                    <item.icon className="h-8 w-8 text-white" />
                  </div>
                  <h4 className="text-xl font-bold heading-playful mb-2" style={{ color: 'var(--text-primary)' }}>
                    {item.title}
                  </h4>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    {item.desc}
                  </p>
                </Card>
              ))
            }
          </div>

          {/* Learning Through Play Video Section */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12">
            <div className="text-center mb-8">
              <h3 className="text-3xl md:text-4xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-orange)' }}>
                Learning Through Play
              </h3>
              <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
                Watch our little learners explore, discover, and grow through joyful activities
              </p>
            </div>
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <video
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/8tpeujmn_Video-78045.mp4"
                controls
                className="w-full h-auto"
                poster="https://customer-assets-7cd3h4nn.emergentagent.net/job_41ad9bc8-daac-4809-894b-90c60487a24b/artifacts/kstr3631_WhatsApp%20Image%202026-07-22%20at%2011.40.04.jpeg"
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
